import { useMemo } from 'react';

export type FeatureValueType =
	| boolean
	| string
	| number
	| Record<string, unknown>
	| undefined;

export type FeatureFlagBridge = {
	getVariation: (key: string) => FeatureValueType;
};

export function useFeatureFlag<T extends FeatureValueType>(
	flag: string,
	featureFlagBridge: FeatureFlagBridge | undefined,
): T {
	return useMemo(
		() => featureFlagBridge?.getVariation(flag) as T,
		[flag, featureFlagBridge],
	);
}
